export const applyListTemplate = (html, pageName = "Documents", docs = []) => {
  const tplWithPage = (html || "").replace(/{%page_name%}/g, pageName);

  const parser = new DOMParser();
  const doc = parser.parseFromString(tplWithPage, "text/html");

  const list = Array.isArray(docs) ? docs : [];

  list.forEach((d) => {
    let node = doc.getElementById(d.slug);

    if (node) {
      // Found by slug → replace contents in place
      node.innerHTML = (node.innerHTML || "").replace(/{%document_name%}/g, d?.name || "Unnamed Document") || d?.name || "Unnamed Document";
      if (d?._id) node.setAttribute("data-doc-id", d._id);
    }

    // Fall back to the "document_item" prototype (all documents in the loop)
    const proto = doc.getElementById("document_item");
    if (proto && proto.parentElement) {
      const clone = proto.cloneNode(true);
      clone.removeAttribute("id");
      clone.innerHTML = (clone.innerHTML || "").replace(/{%document_name%}/g, d?.name || "Unnamed Document") || d?.name || "Unnamed Document";
      if (d?._id) clone.setAttribute("data-doc-id", d._id);
      proto.parentElement.appendChild(clone);
    }
  });

  const proto = doc.getElementById("document_item");
  if (proto && proto.parentElement) proto.remove();

  return "<!doctype html>\n" + doc.documentElement.outerHTML;
};

export const applyMenuTemplate = (html, menus = [], currentUrl = "") => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html || "", "text/html");

  const menuProto = doc.getElementById("menu_item");
  const sidebar = doc.getElementById("sidebar");

  if (!menuProto || !sidebar) return html;

  const normalize = (url) => (typeof url === "string" ? url.replace(/\/$/, "") : "");
  const current = normalize(currentUrl);

  const createChevron = () => {
    const chevron = doc.createElement("span");
    chevron.className = "chevron";
    chevron.setAttribute("data-toggle", "1");
    chevron.innerHTML = `
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    `;
    return chevron;
  };

  const createMenuItem = (item, depth = 0) => {
    const node = menuProto.cloneNode(true);
    node.removeAttribute("id");

    const imageContent = item.image
      ? item.image.includes("svg")
        ? item.image // FOR SVG
        : `<img src="${item.image}" alt="menu icon" class="menu-icon w-5 h-5 object-contain" />` // FOR URL
      : "";

    if (imageContent) {
      const iconSpan = doc.createElement("span");
      iconSpan.innerHTML = imageContent;
      iconSpan.classList.add("menu-icon", "w-5", "h-5", "object-contain");
      node.insertBefore(iconSpan, node.querySelector(".flex-1"));
    }

    node.innerHTML = node.innerHTML.replace(/{%menu_name%}/g, item.name);

    node.setAttribute("data-link", item.link || "#");

    const hasSubmenu = Array.isArray(item.submenu) && item.submenu.length > 0;

    if (hasSubmenu) {
      node.classList.add("has_submenu");
    }

    if (!hasSubmenu) {
      if (current === normalize(item.link)) {
        node.classList.add("active");
      }
      return { node, hasActive: current === normalize(item.link) };
    }

    node.appendChild(createChevron());

    const submenuContainer = doc.createElement("div");
    submenuContainer.className = "submenu-container";

    let hasActiveChild = false;

    item.submenu.forEach((sub) => {
      const result = createMenuItem(sub, depth + 1);
      submenuContainer.appendChild(result.node);
      if (result.hasActive) hasActiveChild = true;
    });

    if (hasActiveChild) {
      submenuContainer.classList.add("open");
      node.querySelector(".chevron")?.classList.add("rotate");
    }

    const wrapper = doc.createElement("div");
    wrapper.className = "mb-1";
    wrapper.appendChild(node);
    wrapper.appendChild(submenuContainer);

    return { node: wrapper, hasActive: hasActiveChild };
  };

  menus.forEach((menu) => {
    const result = createMenuItem(menu);
    sidebar.appendChild(result.node);
  });

  menuProto.remove();

  // Inject Tailwind-based styles into the iframe
  const style = `
    <style>
      .submenu-container { 
        margin-top: 4px; 
        margin-left: 16px; 
        display: none; 
      }
      .submenu-container.open { 
        display: block; 
      }
      .active { 
        background: white !important; 
        color: #0f766e !important; 
      }
      #sidebar::-webkit-scrollbar { 
        width: 6px; 
      }
      #sidebar::-webkit-scrollbar-thumb { 
        background: rgba(255,255,255,0.3); 
        border-radius: 10px; 
      }
    </style>
  `;

  const script = `
    <script>
      document.addEventListener("click", (e) => {
        // Toggling submenu when clicking on the menu item (not just chevron)
        const menuItem = e.target.closest(".menu-header");
        if (menuItem) {
          const wrapper = menuItem.parentElement;
          const container = wrapper.querySelector(".submenu-container");
          if (container) {
            container.classList.toggle("open");
            menuItem.querySelector(".chevron")?.classList.toggle("rotate");
            e.stopPropagation();
            return;
          }
        }

        const link = e.target.closest("[data-link]");
        if (link?.dataset.link && link.dataset.link !== "#") {
          // Remove all active states
          document.querySelectorAll(".active").forEach(el => el.classList.remove("active"));
          
          // Add active to clicked item
          link.classList.add("active");
          
          window.parent.postMessage({ type: "NAVIGATE", link: link.dataset.link }, "*");
        }
      });
    </script>
  `;

  return "<!doctype html>\n" + doc.documentElement.outerHTML.replace("</body>", style + script + "</body>");
};
